import { OutlinedInput } from '@mui/material'
import { updatePartialDocument } from 'api/documents'
import DialogBase from 'components/dialog/Base'
import Field from 'components/ui/Field'
import { useAlert } from 'hooks/useDialog'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import applyErrorMsg from 'utils/applyErrorMsg'

type Props = {
  open: boolean
  setOpenDialog: (x: boolean) => void
  objectID: string
  name: string
  afterUpdated: (newName: string) => void
}

const RenameDocDialog = ({ open, setOpenDialog, objectID, name, afterUpdated }: Props) => {
  const alert = useAlert()

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ mode: 'onChange' })
  const [loading, setLoading] = useState(false)
  const error = errors?.documentName?.message?.toString()

  const close = () => {
    setOpenDialog(false)
  }
  const submit = handleSubmit(async (data) => {
    setLoading(true)
    try {
      await updatePartialDocument(objectID, data)
      afterUpdated(data.documentName)
      close()
    } catch (err) {
      alert({ message: '変更に失敗しました' })
    }
    setLoading(false)
  })
  const { ref, ...rest } = register(
    'documentName',
    applyErrorMsg({
      required: true,
      maxLength: 100,
    }),
  )
  return (
    <DialogBase
      open={open}
      loading={loading}
      title="名前を変更"
      onCancel={close}
      onClose={close}
      onAction={submit}
      actionText="保存"
      cancelText="キャンセル"
      actionProps={{ disabled: Boolean(error) }}
    >
      <Field inline label="名前" labelFor="edit-documentName" error={error}>
        <OutlinedInput
          id="edit-documentName"
          margin="dense"
          sx={{ width: 260 }}
          defaultValue={name}
          inputRef={ref}
          data-testid="edit-document-name"
          {...rest}
        />
      </Field>
    </DialogBase>
  )
}

export default RenameDocDialog
